'use client';

import { createContext, useContext } from 'react';

export type ColorPickerMode = 'solid' | 'gradient';
export type ColorFormat = 'hex' | 'rgb' | 'hsb';

export interface ColorPickerContextValue {
  mode: ColorPickerMode;
  onModeChange?: (mode: ColorPickerMode) => void;
  // null = transparent = None
  value: string | null;
  onChange: (value: string | null) => void;
  onChangeEnd?: (value: string | null) => void;
  isNone: boolean;
  opacity: number;
  onOpacityChange: (opacity: number) => void;
  onOpacityChangeEnd?: (opacity: number) => void;
  format: ColorFormat;
  onFormatChange: (format: ColorFormat) => void;
  lastSolidColor: string;
  setLastSolidColor: (color: string) => void;
}

const ColorPickerContext = createContext<ColorPickerContextValue | null>(null);

export const ColorPickerProvider = ColorPickerContext.Provider;

export const useColorPickerContext = (): ColorPickerContextValue => {
  const context = useContext(ColorPickerContext);
  if (!context) {
    throw new Error('ColorPicker 하위 컴포넌트에서만 사용할 수 있습니다.');
  }
  return context;
};
